export const dateString = (obj, delim) =>
  obj.year + delim + obj.month + delim + obj.day;
